import React from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/store';
import { PRIMARY_DARK } from '../../constants/constants';
import { selectionKeysForBox } from '../../utils/boxes';
import { useVariableBoxForm } from '../VariableHandler/FormCreator/useVariableBoxForm';
import FormBoxName from '../VariableHandler/FormCreator/FormBoxName';
import LabelsArray from '../VariableHandler/LabelsArray';
import BoxFormControlsPortal from './BoxFormControlsPortal';
import DuotoneLightIcon from '../common/DuotoneLightIcon';

// Paramètres de formulaire d'une case à cocher / d'un choix, dans l'inspecteur
// de droite : ils n'étaient accessibles que par la page formulaire, alors qu'une
// variable texte les expose au clic (cf. VariableQuickEditPanel).
//
// Seuls le nom et la liste des réponses sont ici — ce qu'on retouche le plus
// souvent. Réponse unique, nombres min/max, remarque, valeur par défaut et
// valeurs conditionnelles vivent dans le drawer : à 250px de large, tout mettre
// dans le panel repoussait les sections Actions et Style hors de l'écran.
const BoxVariableFormSection = ({ box }) => {
  const { t } = useTranslation();
  const openVariableFormDrawer = useStore(({ openVariableFormDrawer }) => openVariableFormDrawer);
  const { form, onBlur } = useVariableBoxForm(box.id);
  const { arrayKey, selectionKey } = selectionKeysForBox(box);

  return (
    <BoxFormControlsPortal title={t('form')} order={1}>
      <div
        // Des champs portent data-role=pageBackground (ligne de réponse) : le
        // clic remontait au onClick de Layout, qui désélectionne la box — donc
        // démontait cette section en pleine saisie.
        onClick={(event) => event.stopPropagation()}
        className='variable-form-panel'
      >
        <Form
          form={form}
          className='variable-editor__form'
          layout='vertical'
          colon={false}
          validateMessages={{ required: 'Champ obligatoire.' }}
        >
          <FormBoxName box={box} onBlur={onBlur} form={form} />
          <LabelsArray
            box={box}
            onBlur={onBlur}
            form={form}
            arrayKey={arrayKey}
            selectionKey={selectionKey}
            variant='panel'
          />
        </Form>
        <span
          onClick={() => openVariableFormDrawer(box.id)}
          style={{
            cursor: 'pointer',
            color: PRIMARY_DARK,
            fontSize: 13,
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            marginTop: 8,
          }}
        >
          <DuotoneLightIcon name='chevron-left' style={{ fontSize: 11 }} />
          {t('more-form-parameters')}
        </span>
      </div>
    </BoxFormControlsPortal>
  );
};

export default BoxVariableFormSection;
